import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFadeOut24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconFadeOut24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M10.979 22.66a1 1 0 0 1-.245-.034c-5.334-.603-9.48-5.129-9.48-10.624l.014-.55c.265-5.235 4.297-9.473 9.439-10.067a.898.898 0 0 1 1.172.858V21.76a.9.9 0 0 1-.9.9m3.627-.525a.9.9 0 0 1-.9-.9V2.771a.901.901 0 0 1 1.8-.001v18.464a.9.9 0 0 1-.9.9M10.078 3.312c-4.013.858-7.024 4.42-7.024 8.69s3.01 7.835 7.024 8.694zm8.148 16.9a.9.9 0 0 1-.9-.9V4.687a.9.9 0 0 1 1.8 0v14.624c0 .496-.404.9-.9.9m3.623-3.264a.9.9 0 0 1-.9-.9v-8.09a.9.9 0 0 1 1.8 0v8.09a.9.9 0 0 1-.9.901"
            />
        </svg>
    );
}
export default memo(IconFadeOut24);
